"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const memoize_weak_1 = __importDefault(require("memoize-weak"));
const getFieldValuePathWithCaching = memoize_weak_1.default((fieldKey) => [fieldKey].filter(key => !lodash_1.isUndefined(key) && key !== ''));
function getFieldValuePath(field) {
    return getFieldValuePathWithCaching(field.key);
}
exports.default = getFieldValuePath;
